const sprintf = require('sprintf-js').sprintf
const moment = require('moment')

const randstr = function () {
    return Math.random().toString(36).slice(2)
}

if (!/\/$/.test(window.__backendRoot)) {
    window.__backendRoot = window.__backendRoot + '/'
}

if (!/\/$/.test(window.__root)) {
    window.__root = window.__root + '/'
}

const url = function (path) {
    return window.__root + path.replace(/^\//, '')
}

const backendUrl = function (path) {
    return window.__backendRoot + path.replace(/^\//, '')
}
const v1Url = function (path) {
    return window.v1Url + path.replace(/^\//, '')
}

const matrixUrl = function (path) {
    return window.__matrixEndpoint + path.replace(/^\//, '')
}

const mailmanUrl = function (path) {
    return window.__mailmanEndpoint + path.replace(/^\//, '')
}

const agreementUrl = function (path) {
    return window.__agreementEndpoint + path.replace(/^\//, '')
}



const newBackendUrl = function (path) {
    return window.__newBackendEndpoint + path.replace(/^\//, '')
}

const inboxesUrl = function (path) {
    return window.__inboxesEndpoint + path.replace(/^\//, '')
}

const queueUrl = function (path) {
    return window.__queueEndpoint + (path ? path.replace(/^\//, '') : null)
}

const asset = function (path) {
    if (window.__general.assets_remote) {
        return sprintf(window.__general.assets_url, path.replace(/^\//, ''))
    }

    return url(path)
}

const versionedAsset = function (path) {
    path = path.replace(/^\//, '')
    if (window.__general.versioned_assets_remote) {
        return sprintf(window.__general.versioned_assets_url, window.__version, path)
    } else if (window.__general.staging_assets_remote) {
        return sprintf(window.__general.staging_assets_url, window.__root.replace(/\/$/, ''), window.__slugname, window.__version, path)
    }

    return url(`/dist/${path}`)
}

const plural = function (number, singular, plural, none = null) {
    if (number === 1) {
        return sprintf(singular, number)
    } else if (number > 1) {
        return sprintf(plural, number)
    } else {
        return none || sprintf(singular, number)
    }
}

/**
 * Formata uma data em string ou moment para uma data no formato ISO
 * @param date
 * @returns {string|null}
 */
const isoDateTime = function (date) {
    if (moment.isMoment(date)) {
        return date.format('YYYY-MM-DD HH:mm:ss')
    }

    if (date) {
        return moment.utc(date).format('YYYY-MM-DD HH:mm:ss')
    }

    return null
}

/**
 * Formata um moment em string no formato de datas ISO
 * @param date
 * @returns {string|null}
 */
const isoDate = function (date) {
    if (moment.isMoment(date)) {
        return date.format('YYYY-MM-DD')
    }

    if (date) {
        return moment.utc(date).format('YYYY-MM-DD')
    }

    return null
}

/**
 * Formata uma data em string ou moment para uma data no formato Y-m-d H:i:s
 * @param date
 * @returns {null}
 */
const sqlDate = function (date) {
    if (date) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }

    return null
}

const localSqlDate = function (date) {
    if (date) {
        return moment
            .utc(date)
            .local()
            .format('YYYY-MM-DD HH:mm:ss')
    }

    return null
}

const utcSqlDate = function (date) {
    if (date) {
        return moment(date)
            .local()
            .utc()
            .format('YYYY-MM-DD HH:mm:ss')
    }

    return null
}

const formatSqlDate = function (moment) {
    if (moment && moment.format) {
        return moment.format('YYYY-MM-DD HH:mm:ss')
    }

    return null
}

const formatDate = function (value, format) {
    if (value === null) {
        return null
    }

    if (moment.isMoment(value)) {
        return value.format(format)
    }

    const parsedValue = moment.utc(value)

    if (parsedValue && parsedValue.format) {
        return parsedValue.format(format)
    }

    return null
}

const webpackInfo = window.__webpackInfo

const webpackEntry = function (name, prefer = 'js') {
    const { assets } = webpackInfo

    if (assets.hasOwnProperty(name)) {
        if (Array.isArray(assets[name].name)) {
            for (const asset of assets[name].name) {
                if (new RegExp(`\.${prefer}$`).test(asset)) {
                    return versionedAsset(asset)
                }
            }
        } else {
            return versionedAsset(assets[name].name)
        }
    }

    throw new Error(`Asset ${name} não encontrado...`)
}

const getBounds = (el) => {
    const ref = document.documentElement.clientWidth
    const rect = el.getBoundingClientRect()

    return {
        left: rect.left + window.scrollX,
        top: (rect.top + window.scrollY) + (rect.height / 2) + 5,
        width: rect.width,
        height: rect.height,
        right: ref - rect.right
    }
}

const isElementInViewport = (el, delta = null) => {
    const rect = el.getBoundingClientRect()

    const x = rect.x + (rect.width / 2)
    const y = rect.y + (rect.height / 2)

    const visibleEl = document.elementFromPoint(x, y)

    // const div = document.createElement('div')
    // div.style.position = 'fixed'
    // div.style.top = y + 'px'
    // div.style.left = x + 'px'
    // div.style.backgroundColor = 'red'
    // div.style.width = '1px'
    // div.style.height = '1px'
    // div.style.zIndex = '999999999999999'
    // div.style.pointerEvents = 'none'
    // document.body.appendChild(div)

    return visibleEl === el || el.contains(visibleEl)
}

const formatMoney = (_value) => {
    let value = _value || 0

    if (typeof value === 'string') {
        if (value.indexOf('R$') > -1) {
            return value
        } else {
            value = parseFloat(value)
        }
    }

    const x = value.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return `R$ ${x}`
}

module.exports = {
    getBounds,
    isElementInViewport,
    randstr,
    url,
    plural,
    backendUrl,
    matrixUrl,
    mailmanUrl,
    inboxesUrl,
    agreementUrl,
    queueUrl,
    sqlDate,
    localSqlDate,
    utcSqlDate,
    formatSqlDate,
    asset,
    versionedAsset,
    sprintf,
    webpackEntry,
    isoDateTime,
    isoDate,
    formatDate,
    formatMoney,
    newBackendUrl,
    v1Url
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/utils.js